module.exports = __webpack_public_path__ + "static/img/answer01.fb9e2d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/Answer/answer01.jpg
// module id = ckc3
// module chunks = 12